import { render, staticRenderFns } from "./BetslipPossibleWinCombo.vue?vue&type=template&id=495d05d8&scoped=true"
import script from "./BetslipPossibleWinCombo.vue?vue&type=script&lang=js"
export * from "./BetslipPossibleWinCombo.vue?vue&type=script&lang=js"
import style0 from "./BetslipPossibleWinCombo.vue?vue&type=style&index=0&id=495d05d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495d05d8",
  null
  
)

export default component.exports